/**
 * LeadDemoGate — 리드 시연 계정을 시연 화면 안에 가둔다.
 *
 * 보호 라우트 전체의 입구(ProtectedRoute 바로 안쪽)에 딱 한 번 끼운다. 라우트가 100개든
 * 200개든 리드는 반드시 여기를 지나므로, 새 화면이 생겨도 자동으로 막힌다 — 화면마다 가드를
 * 붙이는 방식이면 새로 추가한 사람이 잊는 순간 구멍이 난다.
 *
 * 리드가 아니면 아무 일도 하지 않는다(그냥 통과). 리드이고 허용목록 밖이면 시연 화면으로
 * 되돌린다.
 *
 * ⚠️ **외부용 얼굴로 보는 계정은 여기를 통째로 비켜 간다**(2026-08-27). 그전에는 이 울타리가
 * 바깥에 있어 먼저 이겼고, 외부용 고객 계정(role=lead 로 발급된다)이 열린 기능(신분증 스캔)
 * 으로 못 들어갔다 — 여기서 정책 시연 화면으로 밀어내면 ExternalEditionGate 가 다시 밀어내는
 * 왕복이 났고, 그 정책 화면의 API 는 외부용 잠금이 403 으로 끊어 «이 계정에서 사용할 수 없는
 * 기능입니다» 만 남았다. 리드 시연 울타리는 **내부용 얼굴로 볼 때만** 뜻이 있다.
 *
 * 권한 로딩 중(profile 아직 없음)엔 role 을 모르니 통과시킨다 — 어차피 프로필이 도착하면
 * 다시 렌더돼 제자리를 찾고, 여기서 미리 막으면 로그인 직후 화면이 깜빡인다.
 *
 * ⚠️ 이건 화면 안내용 울타리이지 보안 경계가 아니다. 실제 데이터 차단은 서버가 한다
 * (리드는 매장 무소속이라 정책 조회가 시연용 매장 하나로만 스코프된다 — /board-raw).
 */

import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { useEdition } from "../../context/EditionContext";
import { LEAD_DEMO_PATHS, isLeadDemoPath } from "../../lib/leadDemo";

export default function LeadDemoGate() {
  const { isLead } = useAuth();
  const { edition, ready } = useEdition();
  const { pathname } = useLocation();

  // 선택 이용 매장 화면으로 보는 계정은 이 울타리를 통째로 비켜 간다 — ExternalEditionGate 가 담당한다.
  // (신분 확정 전에는 아무것도 하지 않는다: 여기서 미리 판단하면 체험 계정이 로그인 직후
  //  한 번 시연 화면으로 튕겼다가 돌아오며 화면이 깜빡인다.)
  if (!ready || edition === "partial") return <Outlet />;

  if (isLead() && !isLeadDemoPath(pathname)) {
    return <Navigate to={LEAD_DEMO_PATHS[0]} replace />;
  }
  return <Outlet />;
}
